"use strict";

angular.module("groupJudgementModule",['groupJudgementServiceModule'])
    .controller("groupJudgementCtrl",["$scope", 'trsHttpService', 'groupJudgementService', 'modalDialog',function($scope, trsHttpService, groupJudgementService, modalDialog){
        initStatus();
        initData();
        function initStatus(){
            $scope.status = {
                keywords: ''
            };
            $scope.data = {
                items: [],
                copyCurrPage: 1,
            }
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
            };
        }
        function initData(){
            requestData();
        }
        function requestData(){
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'queryOriginalGroups',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(data){
                if(data){
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER;
                }
                else{
                    $scope.data.items = [];
                }
            });
        }
        $scope.createGroup = function(){
            groupJudgementService.createGroup('','create',1).then(function(){
                requestData();
            });
        }
        $scope.modify = function(modiType,item){//modiType 1:修改名称,2:修改产品
            groupJudgementService.createGroup(item,'modify',modiType).then(function(){
                requestData();
            })
        }
        $scope.delete = function(item){
            modalDialog.alertType('确定删除该分组吗？','','ask',true,function(){
                let params = {
                    serviceid: 'mlf_originalgroup',
                    methodname: 'deleteGroup',
                    ORIGINALGROUPID: item.ORIGINALGROUPID,
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(){
                    modalDialog.alertType('删除成功！','','success',false,function(){
                        requestData();
                    });
                });
            });
        }
        $scope.pageChanged = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        $scope.jumpToPage = function() {
            if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        $scope.selectPageNum = function() {
            $scope.data.copyCurrPage = 1;
            requestData();
        };
    }])